import { getHrefElm, unlinkDomMutation } from '@/components/Content/Palette/EditPartDesign/Editor/TinyMceEditor/Util'

// 通常リンク解除
const setup = function (editor) {
  editor.ui.registry.addIcon(
    'custom_unlink',
    '<svg width="24" height="24"><path d="M6.2 12.3a1 1 0 011.4 1.4l-2 2a2 2 0 102.6 2.8l4.8-4.8a1 1 0 000-1.4 1 1 0 111.4-1.3 2.9 2.9 0 010 4L9.6 20a3.9 3.9 0 01-5.5-5.5l2-2zm11.6-.6a1 1 0 01-1.4-1.4l2.1-2a2 2 0 10-2.7-2.8L11 10.3a1 1 0 000 1.4A1 1 0 119.6 13a2.9 2.9 0 010-4L14.4 4a3.9 3.9 0 015.5 5.5l-2 2zM7.6 6.3a.8.8 0 01-1 1.1L3.3 4.2a.7.7 0 111-1l3.2 3.1zM5.1 8.6a.8.8 0 010 1.5H3a.8.8 0 010-1.5H5zm5-3.5a.8.8 0 01-1.5 0V3a.8.8 0 011.5 0V5zm6 11.8a.8.8 0 011-1l3.2 3.2a.8.8 0 01-1 1L16 17zm-2.2 2a.8.8 0 011.5 0V21a.8.8 0 01-1.5 0V19zm5-3.5a.7.7 0 110-1.5H21a.8.8 0 010 1.5H19z" fill-rule="nonzero"></path></svg>'
  )

  editor.ui.registry.addToggleButton('customUnlink', {
    icon: 'custom_unlink',
    onAction: () => editor.execCommand('customUnlink'),
    onSetup: (buttonApi) => {
      // メニューボタンの状態を管理
      const editorEventCallback = (eventApi) => {
        const hrefElm = getHrefElm(editor, eventApi.element)
        if (!hrefElm) {
          buttonApi.setDisabled(true)
        } else {
          buttonApi.setDisabled(false)
        }
      }
      editor.on('NodeChange', editorEventCallback)
      return function (buttonApi) {
        editor.off('NodeChange', editorEventCallback)
      }
    }
  })

  editor.addCommand('customUnlink', () => {
    unlinkDomMutation(editor)
  })
}

export default { setup }
